import React from 'react';

export default function Section({
    children,
    className = '',
    style = {},
    collapsible = true,
    saveState = true,
    title = null,
    subtitle = null,
    preview = null,
    id = null, // Add id prop for state persistence
    wrapperElement = 'section',
}) {
    const Wrapper = wrapperElement;

    // Helper to get localStorage key
    const getStorageKey = () => id ? `collapse_${id}` : null;

    // Initialize collapsed state from localStorage if saveState is true
    const [isCollapsed, setIsCollapsed] = React.useState(() => {
        if (!collapsible) return false;
        if (saveState && id) {
            const saved = localStorage.getItem(getStorageKey());
            if (saved === 'collapsed') return true;
            if (saved === 'expanded') return false;
        }
        // Default: expanded
        return false;
    });

    // Persist state to localStorage when changed
    React.useEffect(() => {
        if (saveState && id) {
            localStorage.setItem(getStorageKey(), isCollapsed ? 'collapsed' : 'expanded');
        }
    }, [isCollapsed, saveState, id]);

    const handleCollapseToggle = () => {
        if (!collapsible) return;
        setIsCollapsed(prev => !prev);
    };

    let icon = isCollapsed ? <i className="fas fa-angle-right"></i> : <i className="fas fa-angle-down"></i>;
    if (!collapsible) icon = null;

    return (
        <Wrapper
            id={id}
            className={`${className} ${collapsible ? 'collapsible' : ''} ${isCollapsed ? '' : 'expanded'}`}
            style={style}
        >
            {title && <h2 onClick={handleCollapseToggle}>{icon}{title}</h2>}
            {subtitle && <p className="subtitle">{subtitle}</p>}
            {preview && <div onClick={handleCollapseToggle} className="preview">{preview}</div>}
            <div className="content">
                {children}
            </div>
        </Wrapper>
    );

}
